import { get } from "lodash";
import { RELATIONSHIP } from "utils/constants";

export const getAcorisProofHousehold = (subscription) => {
  const relatedPersons = (
    get(subscription, "project.contact.relatedPersons") || []
  ).filter(Boolean);
  const spouse =
    relatedPersons.find(
      (person) => person.relationship === RELATIONSHIP.SPOUSE,
    ) || null;
  const children = relatedPersons.filter(
    (person) => person.relationship === RELATIONSHIP.CHILD,
  );

  return {
    spouse,
    children,
    hasSpouse: Boolean(spouse),
    hasChildren: children.length > 0,
  };
};

export const getAcorisProofPersonLabel = (
  person,
  { fallback, nestedLabel } = {},
) => {
  const roleLabel = nestedLabel || fallback || "";
  const fullName = [
    get(person, "identity.user.firstname"),
    get(person, "identity.user.lastname"),
  ]
    .filter(Boolean)
    .join(" ");

  if (fullName && roleLabel) {
    return `${roleLabel} - ${fullName}`;
  }

  return fullName || roleLabel;
};
